import { useFetch, useRuntimeConfig, } from 'nuxt/app';
import { toRaw, } from 'vue';
/**
 * docs: https://nuxt.com/docs/api/composables/use-fetch
 *
 * @param method http method type
 * @param url request url
 * @param body request body json
 * @param query query params
 *
 * @returns {Promise<*>}
 *
 */
// TODO: test and check other useFetchCustom implementations, maybe refactor useFetchCustom for GET and POST since GET can't have a body (https://stackoverflow.com/questions/74263774/usefetch-get-with-body-json)
// TODO: refactor GET requests with body's to POSTS in the api
export default async function useFetchCustom(method, url, body, query) {
  const config = useRuntimeConfig();
  const options = {
    baseURL: config.public.baseURL,
    method,
    query,
  };

  // checking for a body because useFetch GETs can't have a body
  if (body && Object.keys(body).length > 0) {
    if (method === 'GET') {
      console.error('GET REQUESTS MUST NOT CONTAIN BODY, USE QUERY INSTEAD');
    }
    else {
      options.body = body;
    }
  }

  const authToken = getAuthToken();

  try {
    const { data, status, error, refresh, clear } = await useFetch(url, {
      onRequest({ request, options }) {
        console.log('useFetch request:', request);
        options.headers = {
          'Access-Control-Allow-Origin': config.public.baseURL,
          'Content-Type': 'application/json',
        };
        options.headers.authorization = authToken;
      },
      ...options,
    });

    console.log('data', data, '\nstatus', status, '\nerror', error, '\nrefresh', refresh, '\nclear', clear);

    if (error.value && error.value.statusCode !== 200) {
      const err = {
        response: {
          status: error.value.statusCode,
          data: {
            message: error.value.message,
            status: error.value.statusCode,
            ...error.value.data,
          },
        },
      };
      return Promise.reject(err); // Use Promise.reject instead of throw
    }

    return toRaw(data.value);
  }
  catch (err) {
    return Promise.reject(err); // Catch any other errors and reject them
  }
}

/**
 * returns authToken for Authorization Header in useFetchCustom above
 * @returns {string}
 */
function getAuthToken() {
  const { status } = useAuth();
  let authToken = '';
  if (status.value === 'authenticated') {
    const { token } = useAuth();
    authToken = token.value;
  }
  return authToken;
}
